import React from "react";

import Box from "../../Interface/Box";
import Button from "../../Interface/Button/Button";
import UnlockButton from "../../Interface/UnlockButton";
import {useEthereum} from "../../../EthereumContext";
import {convertBalance} from "../../../utils";
import DelegationModal from "../DelegationModal";
import {useSelector} from "react-redux";
import { useWeb3React } from "@web3-react/core";
import './style.scss';

const nullAddress = "0x0000000000000000000000000000000000000000";

function VotesManager() {
    const { account } = useWeb3React();
    const {xRoobee} = useEthereum();
    const {userBalance, userVotes} = useSelector(store => store.govToken);
    const [delegate, setDelegate] = React.useState(nullAddress)

    React.useEffect(() => {
        const fetchDelegate = async () => {
            if(!!xRoobee) {
                const delegate = await xRoobee.delegates(account);
                setDelegate(delegate);
            }
        };

        fetchDelegate();
    }, [account, xRoobee]);

    const [isDelegateOpen, setIsDelegateOpen] = React.useState(false);

    return (
        <Box className="voting-manager" justify="space-between">
            {isDelegateOpen && <DelegationModal isOpen={isDelegateOpen} setIsOpen={setIsDelegateOpen} />}
            <div>
                <div className="voting-manager-wrapper">
                    <span>Own votes: {convertBalance(userBalance)}</span>
                    <span style={{marginLeft: 20,}}>Delegated votes: {convertBalance(userVotes)}</span>
                </div>
                {
                    delegate !== nullAddress &&
                    <span style={{fontSize: 12, lineHeight: "20px", whiteSpace: 'nowrap'}}>All your votes delegated to {delegate}</span>
                }
            </div>
            <div style={{display: "flex"}}>
                {account ? (
                    <Button className="highlightedButton" onClick={() => setIsDelegateOpen(true)} disabled={ parseFloat(userBalance) === 0 } >
                       + Delegate
                    </Button>
                ) : (
                    <UnlockButton />
                )}
            </div>
        </Box>
    )
}

export default VotesManager;
